export function editorPanelsReposition() {
  const data = this.getCanvasScope()
  const s = this.state

  const {
    priorityCode,
    activeState,
    activeDs,
    activeFunction,
    componentEditor
  } = this.getWindow()

  this.variables({
    activeFunction
  }).changed(() => {
    if (activeFunction) {
      const key = data.activeFunction
      const schema =
        this.getSchema('functions')[key] || this.getSchema('methods')[key]
      const value = this.getFunctions(key) || this.getMethods(key)
      const state = this.call('deepClone', { key, value, ...schema })
      this.FunctionEditor.state.set(state, { forceMonacoUpdate: true })
      this.changeCodePriority('function')
    } else {
      this.FunctionEditor.state.set({ code: null }, { forceMonacoUpdate: true })
      this.changeCodePriority('component')
    }
  })

  this.variables({
    activeState
  }).changed(() => {
    if (activeState) {
      const key = data.activeState
      const schema = this.getSchema('state')[key]
      const value = this.getState(key)
      const state = this.call('deepClone', { key, value, ...schema })
      this.StateEditor.state.set(state, { forceMonacoUpdate: true })
      this.changeCodePriority('state')
    } else {
      this.StateEditor.state.set({ code: null }, { forceMonacoUpdate: true })
      this.changeCodePriority('component')
    }
  })

  this.variables({
    priorityCode
  }).changed(() => {
    const hasComponent = s.value && componentEditor
    if (hasComponent && activeFunction) {
      const componentState =
        !priorityCode || priorityCode === 'component'
          ? '.isActive'
          : '!isActive'
      const functionState =
        priorityCode === 'function' ? '.isActive' : '!isActive'
      this.ComponentEditor.setNodeStyles(
        this.ComponentEditor.props[componentState]
      )
      this.FunctionEditor.setNodeStyles(
        this.FunctionEditor.props[functionState]
      )
    } else {
      this.ComponentEditor.setNodeStyles(
        this.ComponentEditor.props['!isActive']
      )
      this.FunctionEditor.setNodeStyles(this.ComponentEditor.props['!isActive'])
    }
  })
}

export async function createCanvasArtboard(type, key, opts) {
  const Collection = this.getCanvasCollection()
  const item = this.getItem(key, type)
  const element = await Collection.append(
    {
      extends: Collection.childExtend,
      state: item
    },
    `${Collection.content.__ref.__children.length}`
  )

  const frameWindow = this.getCanvasFrameWindow()
  const addedGridItem = frameWindow.gs.addWidget(element.node)

  const gridOpts = {
    w: addedGridItem.getAttribute('gs-w'),
    h: addedGridItem.getAttribute('gs-h'),
    x: addedGridItem.getAttribute('gs-x'),
    y: addedGridItem.getAttribute('gs-y')
  }

  // Quietly save grid settings in database
  window.setTimeout(() => {
    this.sdk.updateData(
      [['update', ['schema', type, key, 'settings', 'gridOptions'], gridOpts]],
      {
        skipSidebar: true
      }
    )
  }, 350)

  if (!opts.skipSelection) {
    this.activateSelected(key)
    this.zoomToNode(this.getSelected())
  }
}
